<template>

  <!-- 1st Hero Variation -->
  <section class="section section_bg">
    <div class="container-fluid ">
      <div class="row">

        <div class=" col-lg-12 justify-content-center">


            <div class="col-md-12 center-block" v-if="is_load_projects==false && is_load_error==false">
              <loading-block v-if="is_load_projects==false && is_load_error==false" :loading="!is_load_projects"/>

            </div>

            <div   v-if="is_load_projects==false && is_load_error==true">
              <div class="alert alert-warning">
                <h2>Ошибка</h2>
                <p>{{ load_error}}</p>
              </div>

            </div>
           <div class="second_section" v-if="is_load_projects==true">
             <div class="col-md-12 center-block" v-if="is_load_projects==true">
               <h2 class="text-center">Задачи на сегодня</h2>
             </div>

             <div class="col-md-12 center-block mt-5 mb-2" v-if="is_load_projects==true">




               <div class="col-lg-12" v-if="tasks.length>0">

                 <div class="row mt-2  team_one_block p-2 "

                     v-for="(project,project_index) in tasks" :key="project.last_id">
                   <div class="row text-clip ">
                      <div class="col-12 col-md-6 col-lg-6">
                     <h5 v-html="project.text_task"></h5>
                     <p><span class="badge badge-info">{{ project.type.title}}</span></p>
                      </div>

                     <div class="col-12 col-md-4 col-lg-4">




                     <p class="mt-2"><span class="badge badge-danger">{{ project.days}}</span></p>
                     <p class="mt-2"><i class="fa fa-calendar"></i><br>{{ project.date_to}}</p>
                     </div>
                     <div class="col-12 col-md-2 col-lg-2">
                       <router-link class="text-clip btn "  tag="a" :to="{name: 'lead', params: { id: project.lead_id }}">
                         <i class="fa fa-link"></i>

                       </router-link>
                     </div>
                   </div>




                 </div>



                   <div class="row second_section d-flex justify-content-center" v-if="total>offset">
                     <button class="btn" @click="loadMore">Загрузить еще</button>

                   </div>



               </div>

             </div>
           </div>

        </div>

      </div>
    </div>
  </section>

</template>
<script>

import {eventBus} from "@/main";
import axios from 'axios';
import Vue from "vue";
import Api from "@/models/Api";
import Modal from "@/components/Modal";

import LoadingBlock from "@/components/Custom/LoadingBlock";


export default {
  name: "home",

  data() {

    var app = this;

    return {
      "is_load_projects": false,
      "projects_table": {
        "current_page": 1,
        "on_page": 30,
        "total": 0,
      },
      "filter":{
        "q":"",
        "type":"projects",
      },
      "statuses": {},

      "current_status": null,
      "iserror": false,
      "error_message": null,
      "form": {
        'json': {},
      },
      is_load_error:false,
      load_error:'',
      "loaded_categorys": false,
      "categorys": null,
      "modal_title": "Создать проект",
      'modals': {
        "add": null,
      },
      limit:20,
      tasks:[],
      offset:0,
      total:0,
      "projects": [],
      "filter_projects": [],
      'is_load_chart': false,
      'circle_chart': {
        chartdata: {
          labels: ['Ищут исполнителя', 'В работе', 'Завершено',],
          datasets: [
            {
              label: 'Data One',
              backgroundColor: ['#03acca', '#ff3709', '#1aae6f'],
              data: []
            },

          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false
        }
      }
    }
  },

  mounted: function () {

    var app = this;
    app.loadMore();







  },
  methods: {
    loadMore(){
      var app=this;
      Api.loadLeadsTasks(app.limit,app.offset,function (data) {
        app.tasks = app.tasks.concat(data.tasks);
        app.offset=data.offset;
        app.total=data.total;
        app.changeStatusFilter();


      },function(error_message){
        app.is_load_projects=false;
        app.is_load_error=true;
        app.load_error=error_message;
      });
    },
    callModalAddProject() {
      eventBus.$emit("call_modal_add_project", {})
      {

      }
    },
    changeStatusFilter() {
      var app = this;
      var projects = [];
      if (Number.isInteger(app.current_status)) {
        app.projects_table.total = 0;
        var total = 0;
        app.filter_projects.forEach(function callback(currentValue, index, array) {
          //your iterator

            projects.push(currentValue);


        });
        app.projects = projects;
      } else {
        app.projects = app.filter_projects;
      }

      app.projects_table.total = app.projects.length;
      app.is_load_projects = true;
    },





  },
  components: {Modal,LoadingBlock}
};
</script>